import * as types from '../constants';

const initialState = {
  reportListTotal: 0,
  reportListItems: [],
  currentPageNumber: 1,
  paginationItem: {
    offset: 0,
    limit: 10,
  },
  filterItem: {
    reportType: 'userkey',
    buildingName: '',
  },
};

const ReportListReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.INIT_REPORT_LIST_STATE:
      return {
        ...state,
        reportListTotal: 0,
        reportListItems: [],
        currentPageNumber: 1,
        paginationItem: {
          offset: 0,
          limit: 10,
        },
        filterItem: {
          reportType: 'userkey',
          buildingName: '',
        },
      };
    case types.SET_REPORT_LIST:
      return {
        ...state,
        reportListTotal: action.payload.total,
        reportListItems: action.payload.items,
      };
    case types.SET_REPORT_LIST_CURRENT_PAGE_NUMBER:
      return {
        ...state,
        currentPageNumber: action.payload,
      };
    case types.SET_REPORT_PAGINATION_ITEM:
      return {
        ...state,
        paginationItem: action.payload,
      };
    case types.SET_REPORT_FILTER_ITEM:
      return {
        ...state,
        filterItem: action.payload,
      };
    default:
      return state;
  }
};

export default ReportListReducer;